class PeerStats {
    constructor() {
        this.stats = {
        };
    }

    update(report) {
        const now = report.timestamp;
        let bytes = report.bytesReceived;
        let headerBytes = report.headerBytesReceived;

        const bitrate = 8 * (bytes - this.stats.bytesReceived) / (now - this.stats.timestamp);
        const headerrate = 8 * (headerBytes - this.stats.headerBytesReceived) / (now - this.stats.timestamp);
        const packetLoss = (this.stats.packetsLost / this.stats.packetsReceived) * 100;

        this.stats = report;
        this.stats.bitrate = bitrate >= 0 ? bitrate.toFixed(1) : 0;
        this.stats.headerrate = headerrate;
        this.stats.jitter = this.stats.jitter * 1000;
        this.stats.packetLoss = packetLoss >= 0 ? packetLoss.toFixed(2) : 0;

        return this.stats;
    }
}

module.exports = PeerStats;